import styled from '@emotion/styled'

const PaddingInset = styled.div`
  padding: 0 0.5rem;
`

export default PaddingInset
